import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=7422ab5b&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=7422ab5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7422ab5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7422ab5b')) {
      api.createRecord('7422ab5b', component.options)
    } else {
      api.reload('7422ab5b', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=7422ab5b&scoped=true&", function () {
      api.rerender('7422ab5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2c2yJ42po6XX0/JS/comp/PopupBox.vue"
export default component.exports